export default __webpack_public_path__ + "media/images/features/saga/bus-e3aff5335c040f957cd3a71a8a99a8ed.png";